import { SHOW_TOAST, HIDE_TOAST } from '../types';

export const hideToast = () => (dispatch) => {
  dispatch({
    type: HIDE_TOAST,
  });
};

export const showToast =
  (type, title, body, actionValue, actionFunction) => (dispatch) => {
    dispatch({
      type: SHOW_TOAST,
      payload: {
        type,
        title,
        body,
        actionValue,
        actionFunction,
      },
    });
  };
